import React from 'react';
import { TextFieldElement, TextareaAutosizeElement } from 'react-hook-form-mui';
import type { CmsEditableTextFieldData } from '@/services/cms/userDefinedForm/CmsEditableTextFieldData';

export type EditableTextFieldProps = CmsEditableTextFieldData;

export function EditableTextField(props: EditableTextFieldProps) {
    return props.rows > 1 ? (
        <TextareaAutosizeElement
            label={props.title}
            name={props.name}
            minRows={props.rows}
            fullWidth={true}
            autoCapitalize={props.autocomplete}
            sx={{
                ' & textarea': {
                    height: `${props.rows * 23}px`, // Adjust height based on number of rows
                },
            }}
        />
    ) : (
        <TextFieldElement label={props.title} name={props.name} minRows={props.rows || undefined} fullWidth={true} />
    );
}
